<div class="text-center text-muted">
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div>
    กำลังโหลด...
  </div>
</div>
